import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import markUrl from "../assets/zentrani-mark.png";
import markLgUrl from "../assets/zentrani-512.png";

const TAGLINE = "Plataforma de gestión residencial para comunidades";

/** Official shield mark + wordmark. When `sub`, larger mark with Spanish tagline. */
export function Logo({ className, sub = false }: { className?: string; sub?: boolean }) {
  if (sub) {
    return (
      <div className={cn("flex flex-col items-center text-center", className)}>
        <img
          src={markLgUrl}
          alt=""
          className="h-auto w-28 object-contain sm:w-32"
          width={512}
          height={512}
          decoding="async"
        />
        <p className="mt-3 text-2xl font-extrabold tracking-tight text-brand-900">Zentrani</p>
        <p className="mt-1 max-w-[16rem] text-xs font-medium uppercase tracking-wide text-ink-muted">
          {TAGLINE}
        </p>
      </div>
    );
  }

  return (
    <div className={cn("flex min-w-0 max-w-full items-center gap-2.5", className)}>
      <img
        src={markUrl}
        alt=""
        className="h-9 w-9 shrink-0 object-contain"
        width={128}
        height={128}
        decoding="async"
        aria-hidden
      />
      <span className="min-w-0 truncate text-lg font-extrabold tracking-tight text-brand-900">Zentrani</span>
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white/60 p-8 text-center">
      <p className="font-semibold text-ink">{title}</p>
      {hint ? <p className="mt-1 text-sm text-ink-muted">{hint}</p> : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  );
}

export function Alert({
  tone = "neutral",
  title,
  children
}: {
  tone?: "neutral" | "go" | "review" | "stop";
  title?: string;
  children?: ReactNode;
}) {
  const tones: Record<string, string> = {
    neutral: "bg-slate-50 text-ink-soft border-slate-200",
    go: "bg-go-soft text-go-fg border-go/20",
    review: "bg-review-soft text-review-fg border-review/20",
    stop: "bg-stop-soft text-stop-fg border-stop/20"
  };
  return (
    <div className={`rounded-xl border p-3 text-sm ${tones[tone]}`}>
      {title ? <p className="font-semibold">{title}</p> : null}
      {children ? <div className={title ? "mt-1" : ""}>{children}</div> : null}
    </div>
  );
}
